import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { AssociateOAuthCredentialRequest } from '../ServerApi/requests/AssociateOAuthCredentialRequest';
import { DeleteOAuthCredentialsRequest } from '../ServerApi/requests/DeleteOAuthCredentialsRequest';
import { DisassociateOAuthCredentialRequest } from '../ServerApi/requests/DisassociateOAuthCredentialRequest';
import { GetCommonUserOAuthCredentialRequest } from '../ServerApi/requests/GetCommonUserOAuthCredentialRequest';
import {
  GetOAuthCredentialAssociatedWithResourceRequest,
} from '../ServerApi/requests/GetOAuthCredentialAssociatedWithResourceRequest';
import { GetOAuthCredentialsRequest, IGetOAuthCredentialsResult } from '../ServerApi/requests/GetOAuthCredentialsRequest';
import { TestOAuthCredentialRequest } from '../ServerApi/requests/TestOAuthCredentialRequest';
import { IOAuthCredential, IOAuthCredentialTypeInfo } from '../ServerApi/types/IOAuthCredential';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { IOAuthCredentialsService } from '../services/OAuthCredentialsService';
import { Resource } from './Resource';

export class OAuthCredentials extends Resource<IOAuthCredential> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory', 'OAuthCredentialsService'];

  constructor(
    private ErrorNotifyingServer: ErrorNotifyingServer,
            FetcherFactory: FetcherFactory,
    private oAuthCredentialsService: IOAuthCredentialsService
  ) {
    super(FetcherFactory.getServerResourceFetcher(
      GetOAuthCredentialsRequest,
      (result: IGetOAuthCredentialsResult) => result.credentials));
  }

  public del(ids: string[]): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteOAuthCredentialsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public test(id: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new TestOAuthCredentialRequest(id));
  }

  public associateWithDatasource(datasourceId: string, credentialId: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new AssociateOAuthCredentialRequest({
      credentialId: credentialId,
      resourceId: datasourceId,
      resourceType: 'Datasource'
    }));
  }

  public disassociateFromDatasource(datasourceId: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new DisassociateOAuthCredentialRequest({
      resourceId: datasourceId,
      resourceType: 'Datasource'
    }));
  }

  public credentialForDatasource(datasourceId: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new GetOAuthCredentialAssociatedWithResourceRequest({
      resourceId: datasourceId,
      resourceType: 'Datasource'
    }));
  }

  public commonCredentialForDatasources(datasourceIds: string[]): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new GetCommonUserOAuthCredentialRequest({
      ids: datasourceIds
    }));
  }

  public canAddForConnectionType(oAuthCredentialTypeInfo: IOAuthCredentialTypeInfo): boolean {
    return this.oAuthCredentialsService.canAddForConnectionType(oAuthCredentialTypeInfo.type);
  }
}

Module.instance().service('OAuthCredentials', OAuthCredentials);
